/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { OLAPTransformerResult, useParameter, useDictionary, Column } from "../../../shared";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe, addYAxisPipe } from "../../../../charts/pipes";
import { dictionaryService } from "../../../dataFlow";
import { arrayByLength, uniq } from "../../../../../shared";
import { last, maxBy } from "lodash";
import { TableProps } from "../../../components/Table";
import { ColDef } from "ag-grid-community";
import { SLIDE_NUMBER } from "../constants";

const COLUMNS_AXIS = "calendar.default";
const ROWS_AXIS = "commodities.default";

export function useAgGridTransformer(olapData: OLAPTransformerResult | null): TableProps | undefined {
  const agGrid = useMemo(() => {
    if (olapData) {
      const maxColumn = maxBy(olapData?.columns, col => col.selection[COLUMNS_AXIS] as number);
      const columns: ColDef[] = [
        { headerName: "", field: "name", resizable: true },
        { headerName: "", field: "value", resizable: true },
      ];
      const rows = olapData?.rows.map(row => {
        const point = row.points.find(p => p.column.selection[COLUMNS_AXIS] === maxColumn?.selection[COLUMNS_AXIS]);
        let name = point?.attributes?.[`${ROWS_AXIS}.name`] || '';
        if (typeof name === "object") {
          name = name[9];
        }
        const formatter = Intl.NumberFormat('es-US', { maximumFractionDigits: 1, minimumFractionDigits: 1, currency: 'USD', style: 'currency' });
        const value = point ? formatter.format(point.value) : '';
        return { 
          name: `${name}:`, 
          value: `${value}/bu`,
        };
      });
      const table: TableProps = {
        columns,
        rows,
      }
      return table;
    }
  }, [olapData]);

  return agGrid;
}
